import { useContext } from "react"
import EventFieldMeta from "../../events/EventFieldMeta"
import EventDataType from "./EventDataType"
import LiveReportRenderContext from "../../../StateManagment/LiveReportRenderContext"

/**
 * @param {object} props
 * @param {import("../../../types/Firebase").EventFields} props.field
 * @param {string} props.selectedActivity
 * @param {string} [props.graphType]
 * @param {string} [props.color] - Primary color override for scale/number/single-series renderers.
 * @param {Array<string>} [props.colorPalette]
 * @param {Object<string, string>} [props.colorOverrides]
 * @param {React.ReactNode} [props.actions] - Optional action buttons to display in the card header
 * @param {React.ReactNode} [props.dashboardOptions] - Optional additional options to display in the card footer (e.g. for dashboard context)
 * @param {string} [props.startDate] - Optional start date for filtering data (in ISO format)
 * @param {string} [props.endDate] - Optional end date for filtering data (in ISO format)
 * @param {object|null} [props.templateActivityData] - Pre-fetched template data blob (from exportTemplateData). When set, leaves use template data instead of Firestore.
 * @returns {JSX.Element}
 */
const EventData = ({
    field,
    startDate,
    endDate,
    selectedActivity,
    graphType = 'line',
    graphColor,
    actions,
    color,
    colorPalette,
    colorOverrides,
    dashboardOptions,
    templateActivityData,
}) => {

  const inLiveReport = useContext(LiveReportRenderContext)

  return (
    <div className="home-kpi-chart-container">
        <div className="home-kpi-description-container" id='dashboard-output-detail-field-container'>
            {!inLiveReport && (
            <div className='home-kpi-question-title-container'>
                {/* <p><EventFieldMeta fieldId={field.ID} /></p> */}
                {actions && <div className='event-data-actions'>{actions}</div>}
            </div>
            )}
            <div className='home-kpi-question-type-container'>
                <EventDataType
                field={field}
                startDate={startDate}
                endDate={endDate}
                selectedActivity={selectedActivity}
                graphType={graphType}
                graphColor={graphColor}
                color={color}
                colorPalette={colorPalette}
                colorOverrides={colorOverrides}
                templateActivityData={templateActivityData}
                />
            </div>
        </div>
        {dashboardOptions}
    </div>
  )
}

export default EventData
